import { Component, OnInit } from '@angular/core';
import {AppService} from '../app.service';
import {ActivatedRoute} from '@angular/router';

declare let $: any;

@Component({
  selector: 'app-verify-page',
  templateUrl: './verify-page.component.html',
  styleUrls: ['./verify-page.component.css']
})
export class VerifyPageComponent implements OnInit {

  constructor(public app: AppService, private route: ActivatedRoute) { }

  ngOnInit() {
    console.log("Params: ", this.route.snapshot.queryParams['testing']);
    const id = this.route.snapshot.queryParams['user'];
    const code = this.route.snapshot.queryParams['code'];
    console.log("ID: ", id, " Code: ", code);
    if (!id || !code) return;
    this.app.verifyAccountByID(id, code).subscribe((r) => {
      console.log("Verify success: ", r);
    }, (error) => {
      console.log("Verify error: ", error);
    });
  }

}
